// Module
var code = "<div>\n  <md-button\n    type=\"button\"\n    class=\"md-raised md-mini md-dynamic\"\n    ng-if=\"vm.assignedUser.confirmation !== 'Declined' && vm.assignedUser.userId !== vm.currentUser.id\"\n    ng-click=\"vm.sendReminder();\"\n    aria-label=\"Send reminder\"\n  >\n    Send reminder\n  </md-button>\n</div>\n";
// Exports
module.exports = code;